/* eslint-disable @typescript-eslint/use-unknown-in-catch-callback-variable -- source-parity port */
/* eslint-disable @typescript-eslint/require-await -- source-parity port */
/* eslint-disable @typescript-eslint/no-unsafe-type-assertion -- source-parity port */
/* eslint-disable @typescript-eslint/no-unsafe-argument -- source-parity port */
/* eslint-disable @typescript-eslint/no-explicit-any -- source-parity port */
/* eslint-disable no-magic-numbers -- source-parity port */
/* eslint-disable @typescript-eslint/no-unsafe-call -- source-parity port */
/* eslint-disable @typescript-eslint/strict-boolean-expressions -- source-parity port */
/* eslint-disable @typescript-eslint/no-unsafe-member-access -- source-parity port */
/* eslint-disable @typescript-eslint/no-unsafe-assignment -- source-parity port */

import { noise } from '@chainsafe/libp2p-noise';
import { yamux } from '@chainsafe/libp2p-yamux';
import { bootstrap } from '@libp2p/bootstrap';
import { floodsub } from '@libp2p/floodsub';
import { identify } from '@libp2p/identify';
import { ping } from '@libp2p/ping';
import { webSockets } from '@libp2p/websockets';
import { createLibp2p } from 'libp2p';

import { P2P_CONFIG } from '@/config/p2pConfig';
import { Libp2pService } from '@/services/abstract/poc/Libp2pService';
import type { LoggerService } from '@/services/abstract/LoggerService';
import type { Logger } from '@/types/Logger';
import type { ConnectionInfo, LibP2pWithServices, NodeOptions } from '@/types/poc/libp2p';

function extractConnectionInfo(conn: any): ConnectionInfo {
  const address = conn.remoteAddr.toString();
  const isDirect = address.includes('/webrtc/') && !address.includes('/p2p-circuit');
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- boolean OR matches source logic
  const isRelay = address.includes('/p2p-circuit') || address.includes('/ws/') || address.includes('/wss/');

  return {
    peerId: conn.remotePeer.toString(),
    address,
    isDirect,
    isRelay,
    direction: conn.direction,
  };
}

type NodeWithErrorHandlers = LibP2pWithServices & {
  __errorHandler?: (event: ErrorEvent) => void;
  __rejectionHandler?: (event: PromiseRejectionEvent) => void;
};

export class Libp2pServiceImpl extends Libp2pService {
  private readonly log: Logger;

  constructor(loggerService: LoggerService) {
    super();
    this.log = loggerService.createLogger({
      namespace: P2P_CONFIG.logging.namespace.libp2p,
    });
  }

  async createNode(options: NodeOptions): Promise<LibP2pWithServices> {
    const uniqueBootstrapPeers = [...new Set(options.bootstrapNodes)].filter(
      (bootstrapPeer) => bootstrapPeer !== ''
    );
    this.log.info(`Bootstrap peers for six ${options.sixId}:`, uniqueBootstrapPeers);

    const callbacks = options.callbacks ?? {};

    if (options.turnConfig != null) {
      this.log.info('Using pre-generated TURN credentials', {
        urls: options.turnConfig.urls,
        expiresAt: options.turnConfig.username,
      });
    } else {
      this.log.warn('No TURN config provided, WebRTC may fail without ICE servers');
    }

    const node = await createLibp2p({
      addresses: {
        listen: [],
        announce: [],
      },
      transports: [webSockets()],
      connectionEncrypters: [noise()],
      streamMuxers: [
        yamux({
          maxInboundStreams: P2P_CONFIG.yamux.maxInboundStreams,
          maxOutboundStreams: P2P_CONFIG.yamux.maxOutboundStreams,
          enableKeepAlive: P2P_CONFIG.yamux.enableKeepAlive,
          keepAliveInterval: P2P_CONFIG.yamux.keepAliveInterval,
          clientStreamWindowSize: P2P_CONFIG.yamux.clientStreamWindowSize,
          maxStreamWindowSize: P2P_CONFIG.yamux.maxStreamWindowSize,
          streamOptions: {
            initialStreamWindowSize: P2P_CONFIG.yamux.initialStreamWindowSize,
            maxStreamWindowSize: P2P_CONFIG.yamux.maxStreamWindowSize,
            maxInboundStreams: P2P_CONFIG.yamux.maxInboundStreams,
            maxOutboundStreams: P2P_CONFIG.yamux.maxOutboundStreams,
          },
        } as any),
      ],
      connectionGater: {
        denyDialMultiaddr: async() => false,
      },
      connectionManager: {
        maxConnections: P2P_CONFIG.connectionManager.maxConnections,
        maxPeerAddrsToDial: P2P_CONFIG.connectionManager.maxPeerAddrsToDial,
        inboundConnectionThreshold: P2P_CONFIG.connectionManager.inboundConnectionThreshold,
        autoDialInterval: P2P_CONFIG.connectionManager.autoDialInterval,
        dialTimeout: P2P_CONFIG.connectionManager.dialTimeout,
      } as any,
      connectionMonitor: {
        enabled: false,
      },
      services: {
        identify: identify(),
        ping: ping({
          timeout: P2P_CONFIG.ping.timeout,
        }),
        pubsub: floodsub(),
        bootstrap: bootstrap({
          list: uniqueBootstrapPeers,
        }),
      },
    });

    await node.start();

    const peerId = node.peerId.toString();
    this.log.info(`Started with peer ID: ${peerId}...`, { groupId: options.sixId });
    this.log.info('DCUTR enabled - will automatically upgrade relay connections to WebRTC', {
      groupId: options.sixId,
    });

    this.setupEventListeners(node, options.sixId, callbacks, uniqueBootstrapPeers);

    return node;
  }

  async stopNode(node: LibP2pWithServices): Promise<void> {
    const peerId = node.peerId.toString();
    this.log.info(`Stopping LibP2P node: ${peerId}...`);

    const nodeWithErrorHandlers = node as NodeWithErrorHandlers;
    if (nodeWithErrorHandlers.__errorHandler != null) {
      window.removeEventListener('error', nodeWithErrorHandlers.__errorHandler);
    }
    if (nodeWithErrorHandlers.__rejectionHandler != null) {
      window.removeEventListener(
        'unhandledrejection',
        nodeWithErrorHandlers.__rejectionHandler
      );
    }

    try {
      await node.stop();
      this.log.info(`LibP2P node stopped: ${peerId}...`);
    } catch (error) {
      this.log.error(`Error stopping LibP2P node ${peerId}...:`, error);
      throw error;
    }
  }

  subscribeToTopic(
    node: LibP2pWithServices,
    topic: string,
    handler: (message: Uint8Array) => void
  ): () => void {
    this.log.debug(`LibP2P subscribing to topic: ${topic}`);
    node.services.pubsub.subscribe(topic);

    const eventHandler = (event: CustomEvent): void => {
      if (event.detail.topic === topic) {
        handler(event.detail.data as Uint8Array);
      }
    };

    node.services.pubsub.addEventListener('message', eventHandler as EventListener);

    return () => {
      this.log.debug(`Unsubscribing from topic: ${topic}`);
      node.services.pubsub.removeEventListener('message', eventHandler as EventListener);
      node.services.pubsub.unsubscribe(topic);
    };
  }

  async publishToTopic(
    node: LibP2pWithServices,
    topic: string,
    data: Uint8Array | string
  ): Promise<void> {
    const messageData =
      typeof data === 'string' ? new TextEncoder().encode(data) : data;

    const peers = node.services.pubsub.getSubscribers(topic);
    if (topic.includes('file-list')) {
      this.log.info(`PUBLISHING to ${topic}`);
      this.log.info(`Subscribers: ${peers.length} peer(s)`);
      if (peers.length > 0) {
        for (const peer of peers) {
          this.log.info(`- ${peer.toString().substring(0, 20)}...`);
        }
      } else {
        this.log.warn('NO SUBSCRIBERS - message will not be received');
      }
    }

    try {
      await node.services.pubsub.publish(topic, messageData);
    } catch (error) {
      const publishError = error as Error;
      if (
        publishError.message.includes('stream') &&
        publishError.message.includes('closed')
      ) {
        this.log.warn(`Stream closed while publishing to ${topic}, may need reconnection`);
      } else {
        this.log.error(`Error publishing to topic ${topic}:`, publishError);
      }
      throw publishError;
    }
  }

  private setupEventListeners(
    node: LibP2pWithServices,
    sixId: string,
    callbacks: NonNullable<NodeOptions['callbacks']>,
    bootstrapNodes: string[]
  ): void {
    const relayAddresses = bootstrapNodes;

    node.addEventListener('connection:open', (event) => {
      const connectionInfo = extractConnectionInfo(event.detail);

      if (connectionInfo.isRelay && connectionInfo.address.includes('12D3KooW')) {
        this.log.info('RELAY CONNECTION ESTABLISHED');
        this.log.info(`Relay: ${connectionInfo.peerId.substring(0, 20)}...`);
      }

      callbacks.onConnectionOpen?.(connectionInfo);
    });

    node.addEventListener('connection:close', (event) => {
      const connectionInfo = extractConnectionInfo(event.detail);
      this.log.debug(`Connection closed: ${connectionInfo.peerId.substring(0, 12)}...`);
      callbacks.onConnectionClose?.(connectionInfo);
    });

    node.addEventListener('peer:connect', (event) => {
      const peerId = event.detail.toString();
      const connections = node.getConnections(event.detail);

      this.log.debug(
        `Peer connected: ${peerId.substring(0, 20)}... (${connections.length} connections)`
      );

      const connectionInfos = connections.map(extractConnectionInfo);
      callbacks.onPeerConnect?.(peerId, connectionInfos);

      const isBootstrapPeer = bootstrapNodes.some((address) => address.includes(peerId));
      if (isBootstrapPeer) {
        this.log.info(`Connected to bootstrap peer (HAP): ${peerId.substring(0, 20)}...`);
        this.log.info('Will re-announce subscriptions after pubsub streams establish...');

        setTimeout(() => {
          this.reannounceSubscriptions(node, peerId);
        }, 3000);
      }
    });

    node.addEventListener('peer:disconnect', (event) => {
      const peerId = event.detail.toString();
      this.log.debug(`Peer disconnected: ${peerId.substring(0, 12)}...`);
      callbacks.onPeerDisconnect?.(peerId);
    });

    node.addEventListener('peer:discovery', (event) => {
      const discoveredPeer = event.detail;
      const peerId = discoveredPeer.id.toString();
      const shortPeerId = `${peerId}...`;

      const isRelayServer = relayAddresses.some((address) => address.includes(peerId));
      if (isRelayServer || peerId === node.peerId.toString()) {
        return;
      }

      const existingConnection = node.getConnections(discoveredPeer.id);
      if (existingConnection.length > 0) {
        return;
      }

      this.log.debug(`Discovered peer ${shortPeerId}, attempting to dial...`);
      node
        .dial(discoveredPeer.id)
        .then(() => {
          this.log.debug(`Successfully dialed ${shortPeerId}`);
        })
        .catch((error: Error) => {
          this.log.debug(`Failed to dial ${shortPeerId}: ${error.message}`);
        });
    });

    node.services.pubsub.addEventListener('subscription-change', (event) => {
      const peerId = event.detail.peerId.toString();
      const subscriptions = event.detail.subscriptions.map((subscription: any) => ({
        topic: subscription.topic,
        subscribe: subscription.subscribe,
      }));

      callbacks.onSubscriptionChange?.(peerId, subscriptions);
    });

    const errorHandler = (event: ErrorEvent): void => {
      const error = event.error;
      if (
        error != null &&
        (error.name === 'StreamStateError' ||
          (error.message?.includes('stream') && error.message?.includes('closed')))
      ) {
        this.log.debug('Suppressed expected stream closure error:', error.message);
        event.preventDefault();
      }
    };

    const rejectionHandler = (event: PromiseRejectionEvent): void => {
      const error = event.reason as Error | undefined;
      if (
        error != null &&
        (error.name === 'StreamStateError' ||
          (error.message.includes('stream') && error.message.includes('closed')))
      ) {
        this.log.debug('Suppressed expected stream rejection:', error.message);
        event.preventDefault();
      }
    };

    window.addEventListener('error', errorHandler);
    window.addEventListener('unhandledrejection', rejectionHandler);

    const nodeWithErrorHandlers = node as NodeWithErrorHandlers;
    nodeWithErrorHandlers.__errorHandler = errorHandler;
    nodeWithErrorHandlers.__rejectionHandler = rejectionHandler;
  }

  private reannounceSubscriptions(node: LibP2pWithServices, targetPeerId: string): void {
    try {
      const topics = node.services.pubsub.getTopics();

      if (topics.length === 0) {
        this.log.info(
          `No subscriptions to re-announce to ${targetPeerId.substring(0, 20)}...`
        );
        return;
      }

      this.log.info(
        `Re-announcing ${topics.length} subscription(s) to HAP ${targetPeerId.substring(0, 20)}...`
      );
      this.log.info(`Topics: ${topics.join(', ')}`);

      for (const topic of topics) {
        node.services.pubsub.unsubscribe(topic);
        node.services.pubsub.subscribe(topic);
        this.log.debug(`Re-subscribed to: ${topic}`);
      }

      this.log.info('Re-announced all subscriptions to HAP');

      setTimeout(() => {
        for (const topic of topics) {
          const subscribers = node.services.pubsub.getSubscribers(topic);
          const hapSubscriber = subscribers.find(
            (peer) => peer.toString() === targetPeerId
          );
          this.log.info(
            `Topic '${topic}': ${subscribers.length} subscriber(s), HAP subscribed: ${
              hapSubscriber != null ? 'YES' : 'NO'
            }`
          );
        }
      }, 1000);
    } catch (error) {
      this.log.error('Error re-announcing subscriptions:', error);
    }
  }
}
